export default __webpack_public_path__ + "static/media/partner-offer-logo-image.fb9aadca.png";